import imageCompression from "browser-image-compression";

export const compressImage = async (
  imageBlob: Blob,
  options: { maxSizeMB: number; maxWidthOrHeight: number; useWebWorker: boolean }
): Promise<Blob> => {
  try {
    // Convert Blob to File
    const file = new File([imageBlob], "image.jpg", { type: imageBlob.type });

    // Compress the image
    const compressedBlob = await imageCompression(file, options);

    return compressedBlob; // Return Blob instead of a Base64 string
  } catch (error) {
    console.error("Error compressing image:", error);
    return imageBlob; // Return the original Blob if compression fails
  }
};